import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./EmailVerifyOTP.css";
import { New_ScrollX2025 } from "../../assets/icons";

const EmailVerifyOTP = (props) => {
    const {
        isSignUpSuccess,
        setIsSignUpSuccess,
        otp,
        setOpt,
        handleSubmitOtp,
        inValidOtp,
        setInValidOtp,
        handleResendOtp,
    } = props;

    const [newUserEmail, setnewUserEmail] = useState("");
    console.log('newUserEmail = ', newUserEmail);

    useEffect(() => {
        try {
            const userInfo = localStorage.getItem("user") || localStorage.getItem("dup-user");
            // console.log(" userInfo => ", userInfo);
            const email = JSON.parse(userInfo || "{}")?.email;
            // console.log("email =>", email);
            if (!email.includes("@")) {
                setnewUserEmail("");
                return;
            }
            const [name, domain] = email.split("@");
            setnewUserEmail(
                name.length <= 2 ? `${name}@${domain}` : `${name[0]}${"*".repeat(name.length - 2)}${name.slice(-1)}@${domain}`
            );
        } catch (error) {
            console.error("Failed to read user data:", error);
            setnewUserEmail("");
        }
    }, []);

    // Ensure OTP is always an array of 6 characters
    const otpArray = otp ? otp.split("").concat(Array(6 - otp.length).fill("")) : Array(6).fill("");

    // Handle OTP change
    const handleChange = (e, index) => {
        const value = e.target.value.replace(/\D/, ""); // Allow only numbers

        const newOtp = [...otpArray]; // Clone OTP array
        newOtp[index] = value; // Update digit

        setOpt(newOtp.join("")); // Update state

        // Move focus to the next field if a digit is entered
        if (value && index < 5) {
            document.getElementById(`otp-${index + 1}`).focus();
        }
    };

    // Handle backspace
    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            const newOtp = [...otpArray];
            newOtp[index] = ""; // Clear current input
            setOpt(newOtp.join("")); // Update state

            // Move focus to the previous field if current field is empty
            if (index > 0) {
                document.getElementById(`otp-${index - 1}`).focus();
            }
        }
    };

    return (
        <>
            <div className="EmailVerifyOTP-Container bg-[#06050c]">

                <div className="EmailVerifyOTP-particles"></div>

                <header className="topbar">
                    <nav className="w-full flex justify-between vorp-nav">
                        <a href="#" className="nav-logo">
                            <span className="nav-logo-icon"><img className="logo-img999 " src={New_ScrollX2025} alt="icon" /></span>
                            <span>ScrollX</span>
                        </a>

                        {/* <div className="top-actionslogin">
                        <span className=" sm:block">Already have an account?</span>
                        <Link to="/register">
                            <span className="text-white sm:block xl:text-[15px] manrope-300 ">Register</span>
                        </Link>
                    </div> */}
                    </nav>
                </header>

                <main className="mainContainer-fullPage">

                    <div className="content-box">

                        <p className="eyebrow">Verify email</p>

                        <h1 className="heading">Check your inbox</h1>

                        <p className="sub"> We sent a 6-digit code to {" "}
                            <strong>{newUserEmail}</strong>. Enter it below to verify
                            your account.
                        </p>

                        <div className="otp-card">

                            <p className="otp-label">One-time code</p>

                            <div className="otp-row" id="otpRow">

                                {otpArray.map((digit, index) => (
                                    <input
                                        className="otp-box"
                                        type="text"
                                        key={index}
                                        id={`otp-${index}`}
                                        maxLength={1}
                                        value={digit}
                                        onChange={(e) => handleChange(e, index)}
                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                        placeholder=""
                                        autoComplete="one-time-code"
                                        inputMode="numeric"
                                        pattern="[0-9]*"
                                        aria-label="Digit 1"
                                    />

                                ))}
                            </div>

                            {/* Invalid OTP Message */}
                            {inValidOtp && <p className="text-red-500 mt-2">{inValidOtp}</p>}

                            <div className="btn-row">
                                <button className="btn-resend" id="resendBtn" type="button"  onClick={handleResendOtp}>Resend code</button>
                                <button className="btn-verify" id="verifyBtn" type="button" onClick={handleSubmitOtp}>Verify Email <span className="arrow">→</span></button>
                            </div>

                            <div className="success-msg" id="successMsg">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                                Email verified. Redirecting you to your dashboard…
                            </div>

                        </div>

                        <p className="resend-hint" id="resendHint">Didn't receive it? Check your spam, or{" "}<span href="#"> send it again </span>.</p>
                    </div>
                </main>

            </div>
        </>

    );
};

export default EmailVerifyOTP;